
// src/web/components/right-sidebar.jsx

import React from 'react'
import connect from '../../connects/right-sidebar'
import {
  Sidebar
} from 'react-toolbox/lib/layout'
import twoColumnLayoutTheme from './themes/two-column-layout.css'

import PickupDiariesPage from './pickup-diaries-page.jsx'
import NotificationsPage from './notifications-page.jsx'
import AttachmentsPage from './attachments-page.jsx'
import UserTimelinePage from './user-timeline-page.jsx'
import SearchTimelinePage from './search-timeline-page.jsx'
import UnreadTimelinePage from './unread-timeline-page.jsx'
import MembersPage from './members-page.jsx'
import LikesReadersPage from './likes-readers-page.jsx'
import KPIPage from './kpi-page.jsx'
import KPIChatPage from './kpi-chart-page.jsx'
import ReportStatusPage from './report-status-page.jsx'
import DashboardPage from './dashboard-page.jsx'
import SubGroupTimelinePage from './sub-group-timeline-page.jsx'
import ChatRoomsPage from './chat-rooms-page.jsx'
import ChatMessagesPage from './chat-messages-page.jsx'
import GoogleCalendarPage from './google-calendar-page.jsx'
import PdfPreviewPage from './pdf-preview-page.jsx'
import GoogleDocPage from './google-doc-page.jsx'
import { hashHistory } from 'react-router'
import { pushRoute } from '../../actions/route'

class RightSidebar extends React.Component {
  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.name != nextProps.name && nextProps.route && nextProps.route.locationBeforeTransitions) {
      const pathname = nextProps.route.locationBeforeTransitions.pathname
      const paths = pathname.split('/')
      if (!_.isNaN(parseInt(paths[paths.length - 1]))) paths.pop()
      if (paths[paths.length - 1] == 'pickup') paths.pop()
      if (paths[paths.length - 1] == 'messages') paths.pop()
      hashHistory.push(paths.join('/'))
    }
  }

  render() {
    const {
      t,
      user,
      group,
      name,
      params,
      children,
    } = this.props

    var Component
    switch(name) {
    case 'pickup_diaries':
      Component = PickupDiariesPage
      break
    case 'notifications':
      Component = NotificationsPage
      break
    case 'attachments':
    case 'voice_player':
      Component = AttachmentsPage
      break
    case 'user_timeline':
      Component = UserTimelinePage
      break
    case 'search_timeline':
      Component = SearchTimelinePage
      break
    case 'unread_timeline':
      Component = UnreadTimelinePage
      break
    case 'group_members':
      Component = MembersPage
      break
    case 'likes_readers':
      Component = LikesReadersPage
      break
    case 'kpi_page':
      Component = KPIPage
      break
    case 'kpi_chart':
      Component = KPIChatPage
      break
    case 'report_status':
      Component = ReportStatusPage
      break
    case 'dashboard':
      Component = DashboardPage
      break
    case 'group_timeline':
      Component = SubGroupTimelinePage
      break
    case 'chat_rooms':
      Component = ChatRoomsPage
      break
    case 'chat_messages':
      Component = ChatMessagesPage
      break
    case 'google_calendar':
      Component = GoogleCalendarPage
      break
    case 'pdf_preview':
      Component = PdfPreviewPage
      break
    case 'google_doc':
      Component = GoogleDocPage
      break
    }

    if (!children && !Component)
      return null

    return children || Component && <Component params={params} user={user} group={group} />
  }
}

export const RawRightSidebar = RightSidebar
export default connect(RightSidebar)



// WEBPACK FOOTER //
// ./src/web/components/right-sidebar.jsx